import * as yup from "yup";
import { Language } from "../../language/English";
import { WHATSAPP_PHONE_NUMBER_MIN_LENGTH, PHONE_COUNTRY_CODE_MAX_LENGTH, PHONE_COUNTRY_CODE_MIN_LENGTH, PHONE_NUMBER_MAX_LENGTH} from "./BusinessConstant";

export const BusinessNotificationValidation = () => {
    return yup.object().shape({
        sendNotificationByEmail : yup.boolean(),
        email : yup.string().email(Language.INVALID_EMAIL).when('sendNotificationByEmail', {
            is : true,
            then : yup.string().required(Language.EMAIL_IS_REQUIRED)
        }),

        sendNotificationByWhatsApp : yup.boolean(),
        whatsappPhoneCountryCode : yup.string().when('sendNotificationByWhatsApp', {
            is : true,
            then : yup.string().required(Language.PHONE_COUNTRY_CODE_IS_REQUIRED).min(PHONE_COUNTRY_CODE_MIN_LENGTH, Language.PHONE_COUNTRY_CODE_LENGTH_ERROR).max(PHONE_COUNTRY_CODE_MAX_LENGTH, Language.PHONE_COUNTRY_CODE_LENGTH_ERROR)
        }),
        whatsappPhoneNumber : yup.string().when('sendNotificationByWhatsApp', {
            is : true,
            then : yup.string().required(Language.PHONE_NUMBER_IS_REQUIRED)
        }),
        sendNotificationBySms : yup.boolean(),
        smsPhoneCountryCode : yup.string().when('sendNotificationBySms', {
            is : true,
            then : yup.string().required(Language.PHONE_COUNTRY_CODE_IS_REQUIRED).min(PHONE_COUNTRY_CODE_MIN_LENGTH, Language.PHONE_COUNTRY_CODE_LENGTH_ERROR).max(PHONE_COUNTRY_CODE_MAX_LENGTH, Language.PHONE_COUNTRY_CODE_LENGTH_ERROR)
        }),
        smsPhoneNumber : yup.string().when('sendNotificationBySms', {
            is : true,
            then : yup.string().required(Language.PHONE_NUMBER_IS_REQUIRED)
        }),    
    });
}